import {generateString, randomRange, createArray} from '@/utils/base.js'

const startMinute = 3
const intervalBetween = 5000
const enemyRange = [2, 5]
// Он появляется случайно на активной территории и останавливает там баллы и развитие, пока его не лопнешь.
// А после лопания он дает +1 балл.
// Появление идет с 3 минуты от 2 до 5 пузырей в минуты на каждой территории.

export default {
    namespaced: true,
    state: {
        minute: 0,
        enemies: [],
        willEnemies: []
    },
    getters: {
        enemyById: state => enemyId => state.enemies.find(enemy => (enemy.id === enemyId)),
        enemyByRegion: state => regionId => state.enemies.filter(enemy => (enemy.region === regionId))[0],
        nextEnemyInRegion: state => regionId => state.willEnemies.find(item => item.region === regionId)
    },
    actions: {
        update ({rootState, rootGetters, state, commit, dispatch, getters}) {
            const minute = rootState.control.minute
            const time = rootState.control.time
            const removeIds = []

            // Create Enemy
            if (minute !== state.minute && startMinute <= minute) {
                commit('minute', minute)
                dispatch('createEnemy')
            }

            state.willEnemies.forEach(enemy => {
                const enemyRegion = getters.enemyByRegion(enemy.region)
                const enemyNext = getters.nextEnemyInRegion(enemy.region)
                const region = rootGetters['regions/regionById'](enemy.region)

                if (region.progress === 100) {
                    removeIds.push(enemyNext.id)
                    return
                }

                if (enemyNext.activateAt < time) {
                    if (!enemyRegion) {
                        commit('addEnemy', enemyNext)
                        removeIds.push(enemyNext.id)
                    }
                }
            })

            removeIds.forEach(id => commit('removeWillEnemy', id))
        },

        createEnemy ({rootState, commit}) {
            const time = rootState.control.time
            const regions = rootState.regions.regions
            const rangeActivate = [time, time + (60 * 1000)]

            regions.forEach(region => {
                const count = randomRange(enemyRange[0], enemyRange[1])
                const ranges = createRanges(rangeActivate, count)

                if (region.progress !== 100) {
                    createArray(count).map((item, index) => {
                        const enemy = {}
                        const range = ranges[index]
                        enemy.id = generateString(8)
                        enemy.region = region.id
                        enemy.data = {id: 0}
                        enemy.place = {
                            top: randomRange(region.zone[0], region.zone[0] + region.zone[3]),
                            left: randomRange(region.zone[1], region.zone[1] + region.zone[2])
                        }
                        enemy.activateAt = randomRange(range[0], range[1])
                        commit('createEnemy', enemy)
                    })
                }
            })
        },

        removeEnemy ({commit, dispatch, getters, rootState}, id) {
            const time = rootState.control.time
            const enemy = getters.enemyById(id)
            const nextEnemyInRegion = getters.nextEnemyInRegion(enemy.region)

            if (nextEnemyInRegion && nextEnemyInRegion.activateAt < time) {
                commit('updateEnemyActivated', {
                    id: nextEnemyInRegion.id,
                    activateAt: time + intervalBetween
                })
            }

            dispatch('history/push', {message: `resolve problems +1ball`, theme: 'success'}, {root: true})
            dispatch('balance/add', 1, {root: true})
            commit('removeEnemy', id)
        },

        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        minute (state, value) {
            state.minute = value
        },

        createEnemy (state, enemy) {
            state.willEnemies.push(enemy)
        },

        addEnemy (state, enemy) {
            state.enemies.push(enemy)
        },

        removeWillEnemy (state, id) {
            const index = state.willEnemies.findIndex(enemy => enemy.id === id)
            state.willEnemies.splice(index, 1)
        },

        removeEnemy (state, id) {
            const index = state.enemies.findIndex(enemy => enemy.id === id)
            state.enemies.splice(index, 1)
        },

        updateEnemyActivated (state, {id, activateAt}) {
            const enemy = state.willEnemies.find(enemy => enemy.id === id)
            enemy.activateAt = activateAt
        },

        reset (state) {
            state.minute = 0
            state.enemies = []
            state.willEnemies = []
        }
    }
}

function createRanges (range, length) {
    const offset = intervalBetween / 2
    const step = (range[1] - range[0]) / length
    return createArray(length).map((item, i) => {
        const start = range[0] + (step * i)
        return [
            start + offset,
            start + step - offset
        ]
    })
}
